import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const ErrorContainer = styled.div`
  display: flex;
  border: 1px solid #d02937;
  background: #f9dbde;
`;

export const ErrorIconContainer = styled.button`
  border-radius: 50%;
  border-width: 0;
  padding: 0 2px 1px 2px;
  margin: 0 ${fromTheme('spacing_xsmall')};
  background-color: transparent;
`;

export const ErrorMessageContainer = styled.pre`
  color: red;
`;
